module.exports = __webpack_public_path__ + "logo_9436-07d641ac9074f82fb6ff1a18c6be0d47.png";


//////////////////
// WEBPACK FOOTER
// ./assets/leagues/logo_9436.png
// module id = 1146
// module chunks = 0 1